module.exports = __webpack_public_path__ + "img/ad-01.a262f0b9.png";